export const validatePassword = password => {
  if (password || password?.length < 8) {
    return /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(password)
  }

  return false
}
